import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Solar, NoSolar } from '../assets'
import SimulationButton from '../components/simulation-button/SimulationButton'
import NavigationButtons from '../components/navigation-buttons/NavigationButtons'
import { updateSimulationInput } from 'store/simulation/actions/updateSimulationInput'
import { nextSimulationStep } from 'store/simulation/actions/switchSimulationStep'
import { useDispatch, useSelector } from 'react-redux'
import { Store } from 'store/types'
import { SimulationInputKeys } from 'store/simulation/types'
import { trackEvent } from 'utils/eventTracking'
import styles from '../components/simulation-button/SimulationButton.module.scss'
import stepStyles from './Steps.module.scss'
import classNames from 'classnames'

export const HasSolarPanelsStep: FC = () => {
  // REDUX STORE
  const { inputs } = useSelector((state: Store) => state.simulation)
  const dispatch = useDispatch()

  // i18n
  const { t } = useTranslation('simulation')

  /**
   * Handles the simulation button click
   *
   * @param hasSolarPanels
   */
  const handleSimulationButtonClick = (hasSolarPanels: boolean) => {
    // Set hasSolarPanels in simulation store
    dispatch(updateSimulationInput({ key: SimulationInputKeys.HAS_SOLAR_PANELS, value: hasSolarPanels }))

    // Track 'Simulation Started' event @Semetis
    trackEvent('simulation_started', {
      solar_panel: hasSolarPanels,
      step: 'has-solar-panels'
    })

    // Go to next step
    dispatch(nextSimulationStep())
  }

  return (
    <div>
      <div className="is-flex-column is-flex-centered">
        <h2 className={classNames(stepStyles.title, 'margin-top-none', 'margin-bottom-l')}>
          {t('doYouHaveSolarTitle', 'Heb je zonnepanelen?')}
        </h2>
      </div>
      <div className={classNames(styles['simulation-buttons'], styles['is-2'])}>
        <SimulationButton
          title={t('yes', 'Ja')}
          icon={<Solar />}
          onClick={() => handleSimulationButtonClick(true)}
          highlighted={inputs.hasSolarPanels === true}
        />

        <SimulationButton
          title={t('no', 'Nee')}
          icon={<NoSolar />}
          onClick={() => handleSimulationButtonClick(false)}
          highlighted={inputs.hasSolarPanels === false}
        />
      </div>

      <NavigationButtons
        nextDisabled={inputs.hasSolarPanels === null}
        onNextClick={() => handleSimulationButtonClick(inputs.hasSolarPanels)}
      />
    </div>
  )
}
